import { prefersReducedMotion } from '@theme/utilities';

const BUTTON_SELECTOR = '[data-back-to-top]';
const SHOW_AFTER_PX = 400;

const initBackToTop = () => {
  const button = document.querySelector(BUTTON_SELECTOR);
  if (!(button instanceof HTMLButtonElement)) return;

  const toggleVisibility = () => {
    const shouldShow = window.scrollY > SHOW_AFTER_PX;
    button.hidden = !shouldShow;
  };

  const handleClick = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: prefersReducedMotion() ? 'instant' : 'smooth',
    });
  };

  toggleVisibility();
  window.addEventListener('scroll', toggleVisibility, { passive: true });
  button.addEventListener('click', handleClick);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBackToTop);
} else {
  initBackToTop();
}